import React from "react";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from "react-toastify";
import { demoUser } from "../../utils/StringUtils";
import { SiteConfig } from "../../models/SiteConfig";

interface OptionComponentProps {
  icon: string;
  title: string;
  description: string;
  onClick?: () => void;
  refUrl?: string;
  userDetails?: any;
  siteConfig?: SiteConfig;
  setMobDialog?: (value: boolean) => void;
  setDemoDialog?: (value: boolean) => void;
  isBackOfficeUser?: () => boolean;
  requestUserContact?: () => void;
}

const OptionComponent: React.FC<OptionComponentProps> = ({
  icon,
  title,
  description,
  onClick,
  refUrl,
  userDetails,
  siteConfig,
  setMobDialog,
  setDemoDialog,
  isBackOfficeUser,
  requestUserContact,
}) => {
  const handleCopyClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering the parent onClick
    
    // Check if user is a demo user
    if (demoUser()) {
      setDemoDialog?.(true);
      return;
    }

    if (!refUrl) return;

    // Check if user can share (similar to handleShare in ProfilePage)
    if (isBackOfficeUser?.() || userDetails?.MobileNumber || siteConfig?.isContactOptional) {
      // User is allowed to copy, proceed with copying
      navigator.clipboard.writeText(refUrl).then(() => {
        toast.success("Referral link copied to clipboard!");
      }).catch(() => {
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = refUrl;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        toast.success("Referral link copied to clipboard!");
      });
    } else {
      // User needs to share contact first
      setMobDialog?.(true);
    }
  };
  return (
    <div
      className={`flex flex-col justify-center items-start p-4 mt-3 max-w-full rounded-lg w-[92%] bg-meitms-color`}
      onClick={onClick}
    >
      <div className="flex gap-3 items-center w-full">
        <div className="flex gap-2.5 items-center self-stretch p-2.5 my-auto w-11 h-11 rounded bg-meicnbg-color flex-shrink-0">
          <img
            loading="lazy"
            src={icon}
            alt={title}
            className="object-contain w-6 aspect-square"
            style={{
              filter:
                title === "FAQ" || title === "Change Password"
                  ? "invert(100%) sepia(0%) saturate(0%) hue-rotate(7deg) brightness(102%) contrast(106%)"
                  : "",
            }}
          />
        </div>
        <div className="flex flex-col self-stretch my-auto flex-1 min-w-0">
          <h2 className="text-sm text-white">{title}</h2>
          <p className="mt-1.5 text-xs text-zinc-400">{description}</p>
        </div>
        {title === "Share" && refUrl && (
          <div className="flex items-center flex-shrink-0">
            <button
              onClick={handleCopyClick}
              className="p-1 text-white hover:text-blue-400 transition-colors"
              title="Copy referral link"
            >
              <ContentCopyIcon sx={{ fontSize: 24 }} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OptionComponent;
